import { Dialog, Stack, DialogContent, DialogActions, Button, Box, CircularProgress } from "@mui/material";
import { DialogTitleClosable } from "../../../components/DialogTitleClosable";
import { bhpButtonSx } from "../../../styles/bhpStyles";
import InfoIcon from '@mui/icons-material/Info';
import CancelIcon from '@mui/icons-material/Cancel';
import { useEffect, useState } from "react";
import { useCardSwapHttp } from "../hooks/useCardSwapHttp";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { CardSwapAuditDto } from "../dtos/CardSwapAuditDto";
import { formatDateTime } from "../../../utils";


const dataGridSx = {

    cursor: 'pointer',

    '.MuiDataGrid-columnHeaderTitle': { 
        fontWeight: 'bold !important',
        overflow: 'visible !important'
    },

    '.MuiDataGrid-cell:focus': {
        outline: 'none'
    },

    '.MuiDataGrid-root .MuiDataGrid-cell': {
        color: 'tomato',
        whiteSpace: 'normal !important',
        wordWrap: 'break-word !important',
    },

    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
        py: '15px',
    }

};


type AuditDialogProps = {

    cardSwapId : number;
    dialogOpen: boolean;
    onClose: ( ) => void;

};


const columns: GridColDef[ ] = [ 

    {
        field: 'message',
        headerName: 'Log Message',
        sortable: false,
        width: 800,
    },

    {
        field: 'updatedBy',
        headerName: 'Updated By',
        sortable: true,
        width: 150,
    },

    {
        field: 'updatedOn',
        headerName: 'Updated On',
        sortable: true,
        width: 200,
        renderCell: ( params => formatDateTime( params.row.updatedOn ) )
    }
    
];

export const AuditDialog : React.FC< AuditDialogProps > = ( props : AuditDialogProps ) => {

    const { cardSwapId, dialogOpen, onClose } = props;

    const [ cardSwapAudits,  setCardSwapAudits ]  = useState< CardSwapAuditDto[ ] >( [ ] );
    const [ isLoading, setIsLoading ] = useState< boolean >( true );
    const [ pageSize, setPageSize ] = useState<number>( 10 );

    const { getCardSwapAudits } = useCardSwapHttp( );

    
    useEffect( () => {

        if( !cardSwapId || !dialogOpen ) {
            
            return;

        }

        const fetchData = async() => {

            const cardSwapAudits = await getCardSwapAudits( cardSwapId );
            setIsLoading( false );
            
            if( cardSwapAudits ){
                
                setCardSwapAudits( cardSwapAudits );

            }

        };

        fetchData( );

        
    }, [ dialogOpen, cardSwapId ]);
    
    
    const handleClose = ( ) => onClose( );
    

    return(
        
        <Dialog
            onClose={ handleClose }
            open={ dialogOpen }
            sx={{ '& .MuiDialog-paper': { width: '1200px', maxWidth: '1200px' } }}
        >
            <DialogTitleClosable onClose={ handleClose }>
                <Stack direction="row" display="flex" alignItems="center" gap={ 0.5 }>
                    <InfoIcon /> Log Messages
                </Stack>
            </DialogTitleClosable>

            <DialogContent dividers>
                
                {                
                    isLoading
                        &&
                    <Box 
                        display="flex" 
                        alignItems="center"
                        justifyContent="center"
                        height={ 100 }

                    >
                        <CircularProgress size={ 80 } sx={{color: '#e65400'}}/>
                    </Box>
                }               

                {
                        cardSwapAudits.length > 0
                            ?
                        <DataGrid
                            getRowHeight={() => 'auto'}    
                            getRowId={ _ => Math.floor(Math.random() * 100_000_000) }
                            pageSize={ pageSize }
                            onPageSizeChange={ newPageSize => setPageSize( newPageSize ) }
                            rowsPerPageOptions={ [ 5, 10, 20 ] }
                            pagination
                            rows={ cardSwapAudits }
                            columns={ columns }
                            autoHeight={ true }
                            sx={ dataGridSx }
                            disableColumnFilter 
                            disableColumnSelector 
                            disableColumnMenu  
                            disableSelectionOnClick 
                        />
                            :
                        <span>No data to display</span>
                    }
                

            </DialogContent>
            
            <DialogActions>

                <Button 
                    onClick={ handleClose } 
                    startIcon={ <CancelIcon /> }
                    sx={{ ...bhpButtonSx, width: '100px' }} 
                >
                    Close
                </Button>
            </DialogActions>

        </Dialog>

    );

};